import React, { useState } from 'react';
import { Icon } from '@/shared/Icon';

type EditElementSectionProps = {
  title: string;
  children: React.ReactNode;
  /** sections holding the less frequently used properties start collapsed */
  defaultExpanded?: boolean;
};

/**
 * A labelled, collapsible group of related controls inside the edit-element dialog.
 * Keeps the heading style consistent across every section (identity, text, shape, etc.).
 */
export const EditElementSection: React.FC<EditElementSectionProps> = ({
  title,
  children,
  defaultExpanded = true,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(defaultExpanded);

  return (
    <section className="flex flex-col gap-3">
      <button
        type="button"
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded(expanded => !expanded)}
        className="flex items-center justify-between border-b border-[#E1E0E6] pb-1 text-sm font-semibold text-font-500"
      >
        <h3>{title}</h3>
        <Icon name={isExpanded ? 'chevron-up' : 'chevron-down'} className="h-4 w-4 fill-font-500" />
      </button>
      {isExpanded && children}
    </section>
  );
};
